import PropTypes from 'prop-types'
import { TablaTopTen } from '@/common/components/tablasInforme/TablaTopTen.jsx'
import { TOP_DENUNCIAS_COLUMNS, SINIESTRALIDAD_COLUMNS } from './columnsTablaTopTen.js'
import { TABLAS_LABELS } from '@/common/constants/labels.js'
import { JudicialesEmptyMessage } from '../EmptyMessage.jsx'

const TablasInforme = ({
  topDenunciantes,
  topDenunciantesLoading,
  topJudiciales,
  topJudicialesLoading,
  topEvolucionSiniestros,
  topEvolucionSiniestrosLoading,
}) => {
  const hasJudicialesData = topJudiciales?.length > 0
  return (
    <div className="mb-28">
      <TablaTopTen
        title={TABLAS_LABELS.TOP_DENUNCIANTES}
        data={topDenunciantes}
        isLoading={topDenunciantesLoading}
        columns={TOP_DENUNCIAS_COLUMNS}
      />
      {hasJudicialesData ? (
        <TablaTopTen
          title={TABLAS_LABELS.TOP_JUDICIALES}
          data={topJudiciales}
          isLoading={topJudicialesLoading}
          columns={TOP_DENUNCIAS_COLUMNS}
        />
      ) : (
        <JudicialesEmptyMessage />
      )}
      <TablaTopTen
        title={TABLAS_LABELS.TOP_SINIESTROS}
        data={topEvolucionSiniestros}
        isLoading={topEvolucionSiniestrosLoading}
        columns={SINIESTRALIDAD_COLUMNS}
      />
    </div>
  )
}

TablasInforme.propTypes = {
  topDenunciantes: PropTypes.array.isRequired,
  topDenunciantesLoading: PropTypes.bool.isRequired,
  topJudiciales: PropTypes.array.isRequired,
  topJudicialesLoading: PropTypes.bool.isRequired,
  topEvolucionSiniestros: PropTypes.array.isRequired,
  topEvolucionSiniestrosLoading: PropTypes.bool.isRequired,
}

export default TablasInforme
